import axios from 'axios'
import type { Event } from '@/types/event'

// Client sans auth pour les routes publiques
const publicClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: { Accept: 'application/json' },
})

export interface PublicTicket {
  uuid: string
  event_name: string
  event_date: string
  event_time: string
  location: string
  ticket_type: string
  ticket_type_description: string | null
  buyer_name: string | null
  quantity: number
  unit_price: number
  total_price: number
  status: 'pending' | 'active' | 'used' | 'cancelled'
  qr_code_url: string | null
  whatsapp_sent: boolean
  buyer_phone: string
  purchased_at: string | null
}

export interface PurchasePayload {
  ticket_type_id: number
  buyer_phone: string
  buyer_name?: string
  quantity: number
  payment_provider: 'wave' | 'orange_money'
}

export interface PurchaseResult {
  ticket_uuid: string
  order_id: string
  ticket_type: string
  quantity: number
  amount: number
  payment_url: string
  expires_at: string
}

export const publicApi = {
  getEvent: async (slug: string): Promise<Event> => {
    const { data } = await publicClient.get(`/public/events/${slug}`)
    return data.data
  },

  purchase: async (slug: string, payload: PurchasePayload): Promise<PurchaseResult> => {
    const { data } = await publicClient.post(`/public/events/${slug}/purchase`, payload)
    return data.data
  },

  getTicket: async (uuid: string): Promise<PublicTicket> => {
    const { data } = await publicClient.get(`/public/tickets/${uuid}`)
    return data.data
  },

  getTicketsByPhone: async (phone: string): Promise<PublicTicket[]> => {
    const { data } = await publicClient.get('/public/tickets', { params: { phone } })
    return data.data
  },
}
